import {  useEffect, useRef, useState } from 'react';
import {
  useInterval,
} from '../../../../../utility/CustomHooks';

const useStreamVolume = (stream, updateInterval = 20, active = true) => {
  const [volume, setVolume] = useState(0);
  const analyserNode = useRef(null);
  const audioContext = useRef(null);
  const mediaStreamAudioSourceNode = useRef(null);

  useEffect(() => {
    async function getMedia() {
      try {
        audioContext.current = new AudioContext();
        mediaStreamAudioSourceNode.current =
          audioContext.current.createMediaStreamSource(stream);
        analyserNode.current = audioContext.current.createAnalyser();
        mediaStreamAudioSourceNode.current.connect(analyserNode.current);
      } catch (err) {
        /* handle the error */
      }
    }
    getMedia();
    return () => {
      if (audioContext.current) {
        audioContext.current.close();
      }
      if (mediaStreamAudioSourceNode.current) {
        mediaStreamAudioSourceNode.current.disconnect();
      }
      if (analyserNode.current) {
        analyserNode.current.disconnect();
      }
    };
  }, [stream]);

  // if muted ensure nothing active
  useEffect(() => {
    if (!active) {
      setVolume(0);
    }
  }, [active]);

  useInterval(() => {
    if (!analyserNode.current) {
      return;
    }
    const bufferLength = analyserNode.current.fftSize;
    const dataArray = new Float32Array(bufferLength);
    analyserNode.current.getFloatTimeDomainData(dataArray);
    let sumSquares = 0.0;
    for (const amplitude of dataArray) {
      sumSquares += amplitude * amplitude;
    }
    const volume = Math.sqrt(sumSquares / dataArray.length);
    setVolume(volume);
  }, updateInterval);

  return volume;
};

export default useStreamVolume;
